import React from "react";
import ButtonToBottomSheet from "./ButtonToBottomSheet";

const VISIBILITY_OPTIONS = [
  { value: "everyone", label: "Everyone" },
  { value: "friends", label: "Friends" },
  { value: "onlyMe", label: "Only me" },
];

function VisibilityButton({ visibility = "everyone", onPress }) {
  const value = VISIBILITY_OPTIONS.find((o) => o.value === visibility)?.label ?? visibility;

  return (
    <ButtonToBottomSheet
      icon="eye-outline"
      label="Who can see this?"
      value={value}
      onPress={onPress}
    />
  );
}

export default VisibilityButton;
export { VISIBILITY_OPTIONS };
